import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { Cms } from '@impact/data';
import { Observable } from 'rxjs';
import { arrowRightIcon } from '../../../../icons';
import { IBooking } from '../../../models/book-workshop.models';
import { RentalCarClass } from '../book-workshop-stepper.component';

@Component({
    selector: 'app-book-workshop-summary',
    template: `
        <h1 class="h4">{{ 'book_workshop.step_summary' | translate }}</h1>
        <p class="book-workshop-summary__description">{{ 'book_workshop.summary_description' | translate }}</p>

        <ng-container [ngSwitch]="scrollready">
            <div class="loader" *ngSwitchCase="false"></div>

            <div class="book-workshop-summary__content" *ngSwitchCase="true">
                <div class="book-workshop-summary__row">
                    <div class="book-workshop-summary__comment-wrapper">
                        <button
                            type="button"
                            class="button--primary book-workshop-summary__show-comment-button"
                            (click)="showCommentField()"
                            [ngSwitch]="showComment"
                        >
                            <span *ngSwitchCase="true">{{ 'book_workshop.comment_close_text' | translate }}</span>
                            <ng-container *ngSwitchCase="false">
                                <span>{{ 'book_workshop.comment_add_text' | translate }}</span>
                                <i class="button__icon"
                                    >${'<svg #editIcon class="svg-edit-icon svg-icon" viewBox="0 0 48 48"><path fill="currentColor" d="M38.4.9c-.6 0-1.2.2-1.7.7l-4.1 4.1 9.7 9.7 4.1-4.1c.9-.9.9-2.5 0-3.4l-6.3-6.3c-.5-.4-1.1-.7-1.7-.7zm-9.5 8.5l-28 28v9.7h9.7l27.9-27.9-9.6-9.8z"/></svg>'}</i
                                >
                            </ng-container>
                        </button>
                        <div class="book-workshop-summary__group book-workshop-summary__comment" *ngIf="showComment">
                            <div class="book-workshop-summary__heading">{{ 'book_workshop.comment_header_text' | translate }}</div>
                            <textarea
                                class="form-text-area"
                                [appAutoFocus]="true"
                                [(ngModel)]="userComment"
                                [placeholder]="'book_workshop.comment_header_text' | translate"
                                rows="5"
                            >
                            </textarea>
                            <div
                                class="book-workshop-summary__comment-helptext"
                                *ngIf="pageContent.summaryCommentInfoText"
                                [innerText]="pageContent.summaryCommentInfoText"
                            ></div>
                        </div>
                    </div>
                </div>

                <div class="book-workshop-summary__row">
                    <div class="book-workshop-summary__group">
                        <div class="book-workshop-summary__heading">{{ 'book_workshop.step_car_info' | translate }}</div>
                        <div *ngIf="booking?.regNumber" class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'book_workshop.reg_number' | translate }}</span>
                            <span class="book-workshop-summary-property__value text-uppercase">{{ booking?.regNumber }}</span>
                        </div>
                        <div *ngIf="booking?.makeName" class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'book_workshop.brand' | translate }}</span>
                            <span class="book-workshop-summary-property__value text-capitalize">{{ booking?.makeName }}</span>
                        </div>
                        <div *ngIf="booking?.modelName" class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'book_workshop.model' | translate }}</span>
                            <span class="book-workshop-summary-property__value text-capitalize">{{ booking?.modelName }}</span>
                        </div>
                        <div *ngIf="booking?.variantName" class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'book_workshop.variant' | translate }}</span>
                            <span class="book-workshop-summary-property__value">{{ booking?.variantName }}</span>
                        </div>
                        <div *ngIf="booking?.mileage" class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'book_workshop.mileage' | translate }}</span>
                            <span class="book-workshop-summary-property__value">{{ booking?.mileage | number }} km</span>
                        </div>
                    </div>
                    <div class="book-workshop-summary__group">
                        <div class="book-workshop-summary__heading">{{ 'book_workshop.step_info' | translate }}</div>
                        <div *ngIf="booking?.firstName" class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'user_information.name' | translate }}</span>
                            <span class="book-workshop-summary-property__value text-capitalize">{{
                                booking?.firstName + ' ' + booking?.lastName
                            }}</span>
                        </div>
                        <div *ngIf="booking?.address" class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'user_information.address' | translate }}</span>
                            <span class="book-workshop-summary-property__value text-capitalize">{{ booking?.address }}</span>
                        </div>
                        <div *ngIf="booking?.zipCode" class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'user_information.postal_number' | translate }}</span>
                            <span class="book-workshop-summary-property__value">{{ booking?.zipCode }}</span>
                        </div>
                        <div *ngIf="booking?.city" class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'user_information.city' | translate }}</span>
                            <span class="book-workshop-summary-property__value text-capitalize">{{ booking?.city }}</span>
                        </div>
                        <div *ngIf="booking?.email" class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'user_information.email' | translate }}</span>
                            <span class="book-workshop-summary-property__value text-lowercase">{{ booking?.email }}</span>
                        </div>
                        <div *ngIf="booking?.phone" class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'user_information.phone_number_short' | translate }}</span>
                            <span class="book-workshop-summary-property__value">{{ booking?.phone }}</span>
                        </div>
                    </div>
                </div>
                <div class="book-workshop-summary__row">
                    <div class="book-workshop-summary__group">
                        <div class="book-workshop-summary__heading">{{ 'book_workshop.step_workshop' | translate }}</div>
                        <div class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'book_workshop.chosen_workshop' | translate }}</span>
                            <span class="book-workshop-summary-property__value">{{ booking?.shop?.displayName }}</span>
                        </div>
                        <div class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'user_information.phone_number_short' | translate }}</span>
                            <span class="book-workshop-summary-property__value">{{ booking?.shop?.telephone }}</span>
                        </div>
                    </div>
                </div>
                <div class="book-workshop-summary__row">
                    <div class="book-workshop-summary__group">
                        <div class="book-workshop-summary__heading">{{ 'book_workshop.services' | translate }}</div>
                        <div class="book-workshop-summary-property" *ngFor="let service of booking?.services">
                            <span class="book-workshop-summary-property__name">{{ service.title }}</span>

                            <span *ngIf="service.price as price" class="book-workshop-summary-property__value">
                                <ng-container *ngIf="price >= 1; else lessThan1">
                                    {{ price | defaultcurrency }}
                                </ng-container>
                                <ng-template #lessThan1>
                                    <ng-container *ngIf="price === 0; else variablePrice">
                                        {{ 'generic.for_free' | translate }}
                                    </ng-container>
                                    <ng-template #variablePrice>
                                        {{ 'generic.variable_price' | translate }}
                                    </ng-template>
                                </ng-template>
                            </span>
                        </div>
                    </div>

                    <div class="book-workshop-summary__group">
                        <div class="book-workshop-summary__heading">{{ 'book_workshop.step_date' | translate }}</div>
                        <div class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'book_workshop.step_date' | translate }}</span>
                            <span class="book-workshop-summary-property__value text-capitalize">{{ date | date: 'dd.MM.yyyy' }}</span>
                        </div>
                        <div class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'book_workshop.point_in_time' | translate }}</span>
                            <span class="book-workshop-summary-property__value">{{ booking?.timeCode }}</span>
                        </div>
                    </div>
                </div>

                <div class="book-workshop-summary__row">
                    <div class="book-workshop-summary__group">
                        <div class="book-workshop-summary__heading">{{ 'book_workshop.step_delivery' | translate }}</div>
                        <div class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'book_workshop.delivery_type' | translate }}</span>
                            <span class="book-workshop-summary-property__value">{{ booking?.delivery }}</span>
                        </div>
                        <div class="book-workshop-summary-property">
                            <span class="book-workshop-summary-property__name">{{ 'book_workshop.address' | translate }}</span>
                            <span class="book-workshop-summary-property__value">{{
                                booking?.address + ', ' + booking?.zipCode + ' ' + booking?.city
                            }}</span>
                        </div>
                        <div class="book-workshop-summary-property" *ngIf="selectedRental">
                            <span class="book-workshop-summary-property__name">{{ 'book_workshop.rental_car_text' | translate }}</span>
                            <span class="book-workshop-summary-property__value">{{ selectedRental?.displayName }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="book-workshop-flow__bottom">
            <div class="book-workshop-flow__bottom-content">
                <app-button
                    buttonClass="book-workshop-stepper-content__continue-button button--tertiary"
                    (click)="previousStepClick()"
                    [disabled]="disableButtonClick"
                    [title]="'book_workshop.back' | translate"
                ></app-button>
                <app-button
                    buttonClass="book-workshop-stepper-content__continue-button button button--primary"
                    [loading]="loading"
                    (click)="onNextStepClick()"
                    [title]="'book_workshop.make_booking' | translate"
                >
                    <i class="button__icon">${arrowRightIcon}</i>
                </app-button>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookWorkshopSummaryComponent implements OnInit {
    @Input() booking: IBooking | null;
    @Input() rentals: RentalCarClass[];
    @Input() pageContent: Cms.BookWorkshopPage;
    @Input() loading = false;
    @Output() nextStep = new EventEmitter();
    @Output() previousStep = new EventEmitter();
    date?: string;
    submitResponse$: Observable<any>;
    disableButtonClick: boolean;
    showComment: boolean;
    userComment: string;
    selectedRental: any;
    scrollready: boolean;

    constructor(private cdr: ChangeDetectorRef) {
        this.scrollready = false;
    }

    ngOnInit() {
        this.date = this.booking?.date?.split('T')[0];
        this.userComment = this.booking?.comment ?? '';
        this.showComment = !!this.userComment;

        if (this.booking?.rentalCarClassName) {
            this.selectedRental = this.rentals.find(carClass => this.booking?.rentalCarClassName === carClass.name);
        }

        setTimeout(() => {
            this.scrollready = true;
            this.cdr.markForCheck();
        }, 500);
    }

    showCommentField() {
        this.showComment = !this.showComment;
    }

    previousStepClick() {
        if (this.disableButtonClick) {
            return;
        }

        if (this.booking && this.userComment) {
            this.booking.comment = this.userComment;
        }

        this.previousStep.emit(this.booking);
    }

    onNextStepClick() {
        if (this.disableButtonClick) {
            return;
        }

        this.disableButtonClick = true;

        if (this.booking) {
            this.booking.comment = this.showComment ? this.userComment : '';
        }

        this.nextStep.emit(this.booking);
    }
}
